import React from 'react';

// Swallows transient R3F applyProps errors from dev-mode JSX __source debug
// injection during the first mount. The scene self-heals immediately, we
// just want to avoid showing CRA's red overlay for these harmless errors.
export default class CanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errKey: 0 };
  }
  static getDerivedStateFromError() {
    return {};
  }
  componentDidCatch(err) {
    // Log quietly; then force a remount so Canvas retries.
    // eslint-disable-next-line no-console
    console.warn('[AstraScene] recovering from transient mount:', err?.message);
    this.setState((s) => ({ errKey: s.errKey + 1 }));
  }
  render() {
    return (
      <React.Fragment key={this.state.errKey}>{this.props.children}</React.Fragment>
    );
  }
}
